import { sortBy } from 'lodash';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import * as api from '../api/api';
import dffLogo from '../assets/img/dff/logo.png';
import * as selectors from '../dff/dff-selectors';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { Toolbar } from '../toolbar/toolbar-component';
import { typeSortMap } from './dff-state';
import './dff.scss';
import { loadUser, selectMount } from './dff-slice';
import { MainMenuComponent } from '../menu/main-menu';

export interface DffStateProps {
}

export interface DffDispatchProps {
}

export interface DffOwnProps extends DffStateProps, DffDispatchProps {
  history: any;
}

export const Dff: React.FC<DffOwnProps> = ({ history }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMounts, setIsLoadingMounts] = useState(true);

  const [mounts, setMounts] = useState([]);

  const mount = useSelector(selectors.mount);
  const user = useSelector(selectors.user);
  const baseUrl = useSelector(selectors.baseUrl);

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Koofr EXP - Duplicate file finder';
  }, []);

  const handleClick = () => {
    if (mount.id) {
      history.push(`/dff/${mount.id}?path=`);
    }
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(selectMount(mounts.filter(mount => mount.id === e.target.value)[0]));
  };

  const loadMounts = () => {
    fetch('/api/v2/mounts')
      .then(results => results.json())
      .then(data => {
        let mountsTemp = data.mounts;
        mountsTemp = mountsTemp.filter((mount: api.Mount) => mount.online && mount.origin === 'hosted');
        mountsTemp = sortBy(mountsTemp, (mount: api.Mount) => {
          return [typeSortMap[mount.type], -mount.isPrimary, mount.name];
        });
        setMounts(m => (m.concat(mountsTemp)));
        dispatch(selectMount(mountsTemp[0]));
        setIsLoadingMounts(false);
      });
  };

  useEffect(() => {
    fetch('/api/v2/user/appconfig')
    .then(results => {
      if (results.ok) {
        return results.json();
      }
      throw new Error(results.status as any);
    })
    .then(data => {
      dispatch(loadUser(data));
      setIsLoading(false);
    })
    .then(() => {
      loadMounts();
    })
    .catch(err => {
      console.error(err);
      setIsLoadingMounts(false);
      setIsLoading(false);
    });
  }, []);

  const mountName = (mount: api.Mount) => (
    <option
      value={mount.id}
      key={mount.id}
      disabled={mount.origin !== 'hosted'}
      >
        { mount.name } { mount.type === 'import' ? `(shared by ${mount.owner.name})` : ''}
    </option>
  );

  return (
    <div className="dff">
        <Toolbar>
          <div className='l-toolbar__column'>
            <Link to="/">
              <img src={dffLogo} alt="Koofr DFF logo" className="l-toolbar__logo"/>
            </Link>
            <div className='divider'></div>
            <div className='app-name'>Duplicate file finder</div>
          </div>
          <div className='l-toolbar__column stretch'></div>
          <div className='l-toolbar__column'>
            { user ? 
              (
                <>
                  <div className='divider'></div>
                  <MainMenuComponent/>
                </>
              )
              : null
            }
          </div>
        </Toolbar>
        <div className="dff-container">
          <h1>Koofr duplicate file finder</h1>
          <h2>Find and remove duplicate files inside your Koofr account with ease.</h2>

          {
            !isLoading && !user ? (
              <a href={`/login?redirect=${encodeURIComponent("/dff/")}`} className="login-button">Sign in with Koofr</a>
            ) : null
          }

          {
            !isLoadingMounts && user && user.extra.subscription.isPayingUser && mounts ? (
              <div className="mount-selector">
                <select name="mountSelector" className="dropdown" value={mount.id} onChange={handleSelectChange}>
                  {
                    mounts.map((mount) => mountName(mount))
                  }
                </select>
                <button className="analyse-button" onClick={handleClick}>Go</button>
              </div>
            ) : null
          }

          {
            !isLoading && user && !user.extra.subscription.isPayingUser ? (
              <div className="upgrade">
                <p className="upgrade__text">Koofr duplicate file finder is only available to paying users.</p>
                <a href={`${baseUrl}/app/account`} className="login-button">Upgrade your account</a>
              </div>
            ) : null

          }

          { isLoadingMounts ? (
            <LoadingSpinner />
          ) : null}
        </div>
    </div>
  );
};
